<template>
  <div class="template-detail__mobile-menu">
    <template v-if="variant === 'edit'">
      <!-- template status -->
      <TemplatesStatusControl :template="template" short-messages :show-info="false" />
      <!-- variant toggle -->
      <AppRouterLink
        class="template-details__actions-details"
        exact
        :to="{ name: 'template-details' }"
        text="Detalle de plantilla"
      >
        <AppIcon icon="far fa-info-square" />
      </AppRouterLink>
      <!-- publish -->
      <TemplatesPublishButton />
    </template>
    <!-- DETAILS VARIANT -->
    <template v-else>
      <!-- variant toggle -->
      <AppRouterLink
        class="template-details__actions-details"
        exact
        :to="{ name: 'template-edit' }"
        text="Editar"
      >
        <AppIcon icon="far fa-edit" />
      </AppRouterLink>
      <!-- publish -->
      <TemplatesUnpublishButton :disabled="!mainIsPublished" />
    </template>
  </div>
</template>

<script>
// Components
import AppIcon from 'Ui/AppIcon'
import AppRouterLink from 'Ui/AppRouterLink'
import TemplatesPublishButton from './TemplatesPublishButton'
import TemplatesUnpublishButton from './TemplatesUnpublishButton'
import TemplatesStatusControl from './TemplatesStatusControl'

export default {
  name: 'TemplatesMobileMenu',

  components: {
    AppIcon,
    AppRouterLink,
    TemplatesStatusControl,
    TemplatesPublishButton,
    TemplatesUnpublishButton,
  },
  props: {
    variant: {
      type: String,
      required: true,
    },

    template: {
      type: Object,
      required: true,
    },
  },

  computed: {
    mainTemplate() {
      return this.$store.state.templates.templatePublished
    },

    mainIsPublished() {
      return this.mainTemplate.status === 'published'
    },
  },
}
</script>

<style scoped>
.template-detail__mobile-menu {
  display: flex;
  flex-direction: column;
  padding: 10px 5px;
  height: 200px;
}

.template-detail__mobile-menu >>> .templates-status {
  margin: 0;
  margin-bottom: 20px;
}

.template-detail__mobile-menu >>> .templates-status__label {
  grid-template-columns: auto 1fr;
  grid-gap: 10px;
}

.template-detail__mobile-menu .app-link,
.template-detail__mobile-menu >>> .templates-status__label span {
  font-weight: 700;
  color: var(--c-primary);
  text-decoration: none;
}

.template-detail__mobile-menu >>> .templates-status__label .app-icon {
  color: var(--c-secondary);
}

.template-detail__mobile-menu .app-link {
  display: flex;
  align-items: center;
  padding: 10px;
  width: 100%;
  border-radius: 4px;
  margin: 0 0 0 -10px;
  white-space: nowrap;
}

.template-detail__mobile-menu .app-link .app-icon {
  font-size: 16px;
  margin-right: 10px;
  color: var(--c-secondary);
}

.template-detail__mobile-menu .submit-button {
  width: 100%;
  margin-top: auto;
}
</style>
